import { render } from "./restart.svg?vue&type=template&id=7d62ce72"
const script = {}
script.render = render

export default script